// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#collection-share-email-recipient-keyword[data-v-31232514]{display:none;width:auto;height:20px;border:none}#collection-share-email-recipient-keyword[data-v-31232514]:focus{background-color:#f8f9fa}.modal-body[data-v-31232514]{min-height:350px}", ""]);
// Exports
module.exports = exports;
